<template>
    <v-menu left bottom>
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" :loading="isBusy">
                <v-icon>mdi-translate</v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item v-for="language in languages"
                         :key="language.value"
                         @click="onLanguageChange(language.value)"
            >
                <v-list-item-title>{{ language.title }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    import {API} from "@/api/api";
    import SnackbarMixin from "@/mixins/SnackbarMixin";

    export default {
        name: 'SelectLanguageComponent',
        mixins: [SnackbarMixin],
        data: () => ({
            // loading
            isBusyLanguageChange: false
        }),
        computed: {
            isBusy() {
                return this.isBusyLanguageChange;
            },
            languages() {
                return [
                    {
                        title: 'Česky',
                        value: 'cs'
                    },
                    {
                        title: 'English',
                        value: 'en'
                    },
                    {
                        title: 'Magyar',
                        value: 'hu'
                    }
                ];
            }
        },
        methods: {
            onLanguageChange(language) {
                let userId = this.$store.getters['identity/getUserId'];
                if (userId !== null) {
                    // user is logged in so change locale in database too
                    let data = {
                        locale: language
                    };

                    this.isBusyLanguageChange = true;
                    API.put('/api/users/' + encodeURI(userId) + '/locale', data)
                        .then(() => {
                            this.$i18n.locale = language;
                            this.$store.commit('identity/setLocale', language);
                            this.snackbarSuccess(this.$t('snackbar.language_changed_successfully'));
                        })
                        .catch(error => {
                            this.snackbarError(error);
                        })
                        .finally(() => {
                            this.isBusyLanguageChange = false;
                        });
                }

                // change locale on frontend
                this.$i18n.locale = language;
                this.$store.commit('identity/setLocale', language);
                document.getElementsByTagName('html')[0].setAttribute('lang', language);

                this.snackbarSuccess(this.$t('snackbar.language_changed_successfully'));
            }
        }
    }
</script>
